module.exports = __webpack_public_path__ + "static/media/121.03f6436f.jpg";